import React, { useState, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import IntlMessages from '../../../utils/IntlMessages';
import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import { Box, fade } from '@material-ui/core';
import { AuhMethods } from '../../../../services/auth';
import ContentLoader from '../../ContentLoader';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CmtImage from '../../../../@coremat/CmtImage';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { CurrentAuthMethod } from '../../../constants/AppConstants';
import { NavLink } from 'react-router-dom';
import AuthWrapper from './AuthWrapper';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../../context/AuthContext';
import LinearProgress from '@material-ui/core/LinearProgress';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
import { Collapse, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
// import PersonIcon from '@material-ui/icons/Person';
import EmailIcon from '@material-ui/icons/Email';
import LockIcon from '@material-ui/icons/Lock';
import InputAdornment from '@material-ui/core/InputAdornment';
import { useSnackbar } from 'notistack';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const useStyles = makeStyles(theme => ({
  authThumb: {
    backgroundColor: fade(theme.palette.primary.main, 0.12),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '50%',
      order: 1,
    },
  },
  authContent: {
    padding: 30,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: props => (props.variant === 'default' ? '50%' : '100%'),
      order: 1,
    },
    [theme.breakpoints.up('xl')]: {
      padding: 50,
    },
  },
  titleRoot: {
    marginBottom: 22,
    color: theme.palette.text.primary,
    textAlign: 'center',
    fontSize: '26px',
  },
  textFieldRoot: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: fade(theme.palette.common.dark, 0.12),
    },
  },
  formcontrolLabelRoot: {
    '& .MuiFormControlLabel-label': {
      [theme.breakpoints.down('xs')]: {
        fontSize: 12,
      },
      color: '#000132',
    },
  },
}));
//variant = 'default', 'standard'
const SignIn = ({ method = CurrentAuthMethod, variant = 'default', wrapperVariant = 'default' }) => {
  let history = useHistory();
  const { login } = useContext(AuthContext);
  const [email, setEmail] = useState('administrator@globpay.com');
  const [password, setPassword] = useState('Password100@');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = () => {
    setShowPassword(!showPassword);
  };

  const validation = () => {
    let isError = false;
    if (!email.trim()) {
      handleSnakbarOpen('Please enter email address', 'error');
      document.getElementById('email').focus();
      // console.log('Email');
      return (isError = true);
    } else if (!/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) {
      handleSnakbarOpen('Invalid email address', 'error');
      document.getElementById('email').focus();
      // console.log('Invalid email');
      return (isError = true);
    }

    if (!password.trim()) {
      handleSnakbarOpen('Please enter password', 'error');
      document.getElementById('password').focus();
      return (isError = true);
    }
    // console.log('finish');
    return isError;
  };

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };
  const classes = useStyles({ variant });

  const onSubmit = async e => {
    e.preventDefault();
    let err = validation();
    // console.log('err', err);
    if (err) {
      return;
    } else {
      setLoading(true);
      try {
        let data = {
          email,
          password,
          grant_type: process.env.REACT_APP_GRANT_TYPE,
          client_id: process.env.REACT_APP_CLIENT_ID,
          client_secret: process.env.REACT_APP_CLIENT_SECRECT,
          scope: process.env.REACT_APP_SCOPE,
        };
        let response = await axios({
          url: '/api/v1/public/auth/signin',
          method: 'post',
          data: data,
        });
        // console.log('response.data.data', response.data.message);
        handleSnakbarOpen(response.data.message, 'success');
        login(response.data.data);
        history.push('/dashboard');
      } catch (error) {
        // console.log('error', error);
        // console.log('errorresponse', error.response);
        handleSnakbarOpen(error.response.data.errors.toString(), 'error');
        setOpen(true);
      }
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <AuthWrapper variant={wrapperVariant}>
        {/* <div style={{position:'absolute',left:'Calc(50% - 80px)'}}>
        <img src={'/images/logo.png'} />
        </div> */}
        {variant === 'default' ? (
          <Box className={classes.authThumb}>
            <CmtImage src={'/images/auth/login-img.png'} />
          </Box>
        ) : null}
        <Box className={classes.authContent}>
          {/* {loading ? <LinearProgress /> : null} */}
          <Box mt={3} mb={1} style={{ textAlign: 'center' }}>
            <CmtImage src="/images/logo.png" alt="Shimanto Bank" style={{ maxHeight: 56, width: 'auto', objectFit: 'contain' }} />
          </Box>
          <Typography component="div" variant="h1" className={classes.titleRoot}>
            Login Your Account
          </Typography>

          {/* <Collapse in={open}>
            <Alert
              variant="outlined"
              severity="error"
              className={classes.alertRoot}
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpen(false);
                  }}>
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }>
              {message}
            </Alert>
          </Collapse> */}
          <form>
            <Box mb={2}>
              <TextField
                label="Email"
                id="email"
                fullWidth
                onChange={event => setEmail(event.target.value)}
                defaultValue={email}
                margin="normal"
                variant="standard"
                className={classes.textFieldRoot}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {' '}
                      <EmailIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box mb={2}>
              <TextField
                type={showPassword ? 'text' : 'password'}
                label="Password"
                id="password"
                fullWidth
                onChange={event => setPassword(event.target.value)}
                defaultValue={password}
                margin="normal"
                variant="standard"
                className={classes.textFieldRoot}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {' '}
                      <LockIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}>
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>

            <Box display="flex" alignItems="center" justifyContent="space-between" mt={10} mb={5}>
              <Button
                disabled={loading}
                style={{ width: '100%', padding: '10px 0' }}
                onClick={onSubmit}
                variant="contained"
                color="primary">
                {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}

                <IntlMessages id="appModule.signIn" />
              </Button>

              {/* <Box component="p" fontSize={{ xs: 12, sm: 16 }}>
              <NavLink to="/signup">
                <IntlMessages id="signIn.signUp" />
              </NavLink>
            </Box> */}
            </Box>
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={5}>
              <FormControlLabel
                className={classes.formcontrolLabelRoot}
                control={<Checkbox name="checkedA" color="primary" />}
                label="Remember me"
              />
              <Box component="p" fontSize={{ xs: 12, sm: 16 }}>
                <NavLink to="/forgot-password" style={{ color: '#000132' }}>
                  {/* <IntlMessages id="appModule.forgotPassword" /> */}
                  Forgot Password ?
                </NavLink>
              </Box>
            </Box>
          </form>

          {dispatch(AuhMethods[method].getSocialMediaIcons())}

          <ContentLoader />
        </Box>
      </AuthWrapper>
    </React.Fragment>
  );
};

export default SignIn;
